import angular from 'angular';
import 'angular-ui-router';
import 'ng-file-upload/dist/ng-file-upload';
import 'angular-modal-service';
import Filters from '../../filters/filters';
import template from './bannerCreativesForm.jade';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ProgressBarSetter from '../../services/progressBarSetter';
import {buildCreativeDefinition,copyCreativeDefinition} from './creativesTextBlock';
import WebFont from 'webfontloader';
import Rx from 'rx';
import copyContentModalTemplate from './copyContentModal.jade';

export class BannerCreativesFormController {
  /* @ngInject */
  constructor($scope, $element, $timeout, $window, currentGame, GamesResource, $stateParams, $filter, Upload, setProgressBar, ModalService, DynamicBannerPreviewResource, notify, corsProxy, $sce) {
    this.$scope = $scope;
    this.$sce = $sce;
    this.$window = $window;
    this.GamesResource = GamesResource;
    this.currentGame = currentGame;
    this.$stateParams = $stateParams;
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.setProgressBar = setProgressBar;
    this.ModalService = ModalService;
    this.DynamicBannerPreviewResource = DynamicBannerPreviewResource;
    this.notify = notify;
    this.buildCreativeDefinition = buildCreativeDefinition;
    this.copyCreativeDefinition = copyCreativeDefinition;
    this.activeTextBlock = null;
    this.corsProxy = corsProxy;
    this.statusOptions =	[
      {name: 'active', value: true},
      {name: 'inactive', value: false}
    ];
    this.fontOptions = [
      'Alegreya Sans',
      'Arial',
      'Arimo',
      'Arvo',
      'Bitter',
      'Cabin',
      'Dosis',
      'Droid Sans',
      'Droid Serif',
      'Fjalla One',
      'Helvetica',
      'Indie Flower',
      'Lato',
      'Lobster',
      'Lora',
      'Merriweather',
      'Montserrat',
      'Noto Sans',
      'Noto Serif',
      'Open Sans Condensed',
      'Open Sans',
      'Oswald',
      'Oxygen',
      'Playfair Display',
      'Poiret One',
      'PT Sans Narrow',
      'PT Sans',
      'PT Serif',
      'Raleway',
      'Roboto Condensed',
      'Roboto Slab',
      'Roboto',
      'Slabo 27px',
      'Source Sans Pro',
      'Titillium Web',
      'Ubuntu',
      'Yanone Kaffeesatz'
    ];

    WebFont.load({
      google: {
        families: this.fontOptions
      }
    });

    if(!this.creative.id) {
      this.creative.active = true;
    }

    this.creativeDefinition = new Rx.Subject();

    this.creativeDefinition
      .debounce(200)
      .distinctUntilChanged(JSON.stringify)
      .subscribe(([definition,url]) => {
        if (definition && this.creative.format != 'Dynamic') {
          this.getLivePreviewTemplate().then((res) => this.creativeLiveUrl = res);
        }
      });

    this.currentGame.subscribe(game => this.getBannerFieldsForPersonalization(game));

    let vm = this;
    $scope.$watch('[vm.creative.definition, vm.creativeUrl]', (newValue) => {
      this.setCreativeSize(newValue[1]);
      if (this.creative.definition)
        this.activeTextBlock = _.find(this.creative.definition.lines, {editing: true});
      this.creativeDefinition.onNext(newValue);
    }, true);

    $scope.$on('scrollToCreative', (event, creativeId) => {
      if (this.creative && String(this.creative.id) === String(creativeId)) {
        $timeout(() => {
          const el = $element[0];
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          el.classList.add('is-highlighted');
          $timeout(() => el.classList.remove('is-highlighted'), 2000);
          if (this.creativeUrl) {
            this.openPreview();
          }
        }, 300);
      }
    });
  }

  setCreativeSize(url) {
    let vm = this;
    if(url) {
      if(url.substring(0,4) === 'blob') {
        vm.setImageWeight(vm.creative.file.size);
      } else {
        if (url.match('^http:\/\/com-youappi-dsp-cdn.s3-website-us-east-1.amazonaws.com/creatives')) {
          url = url.replace(/http:\/\/com-youappi-dsp-cdn.s3-website-us-east-1.amazonaws.com\/creatives/, 'https:\/\/creatives.dsp.youappi.com');
        } else {
          url = this.corsProxy.getProxyPrefix() + url;
        }
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "arraybuffer";
        xhr.onreadystatechange = function() {
          if(this.readyState == this.DONE) {
            vm.setImageWeight(this.response ? this.response.byteLength : 0);
          }
        };
        xhr.send(null);
      }
    }

  }

  getBannerFieldsForPersonalization(game) {
    if (!game) {
      return;
    }

    this.bannerFieldsForPersonalization = _.chain(game.custom_field_configs)
      .keys().map((key) => {
        return {
          value: `{{${key}}}`,
          name: game.custom_field_configs[key].field_label,
          for_personalization: game.custom_field_configs[key].for_personalization
        };
      })
      .filter('for_personalization')
      .value();
  }

  setImageWeight(byteLength) {
    this.imageWeightKb = byteLength ? Math.floor(byteLength/1000) + 'kb' : '';
    this.creativeWeightAlert = this.creative.size === '320x50' ? byteLength >= 20000 : byteLength >= 200000;
  }

  handleNewFile(newFile){
    if(newFile){
      this.$scope.$emit('newFileUploaded', newFile, this.creative);
      this.setProgressBar(this, 1, 1);
    }
  }

  removeFile(){
    this.creative.file = null;
    this.creative.url = null;
  }

  removeCreative() {
    if (!this.creative.id) {
      let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.type == this.creative.type;});
      if (indexOfCreativeToRemove > -1) {
        this.variation.creatives.splice(indexOfCreativeToRemove,1);
      }
    } else {
      this.creative.is_deleted = true;
      return this.GamesResource.one(this.$stateParams.gameId).one('variations', this.creative.variation_id).one('creatives', this.creative.id).customPUT(this.creative)
          .then((creativeRes) => {
            let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.id == this.creative.id;});
            if (indexOfCreativeToRemove > -1) {
              this.variation.creatives.splice(indexOfCreativeToRemove,1);
            }
          });
    }
  }

  get creatives() {
    return _.chain(this.variation).map('creatives').flatten().value();
  }

  latestCreative() {
    return _.chain(this.creatives).filter('timestamp').sortBy('timestamp').last().value();
  }

  startCustomize(){
    this.creative.definition = this.buildCreativeDefinition(this.creative.size);
    this.copyCreativeDefinition(this.latestCreative(), this.creative);
    this.creative.customize = true;
    this.creative.timestamp = new Date();
  }

  cancelCustomize(){
    this.creative.definition = null;
    this.creative.customize = false;
  }

  get creativeUrl() {
    return this.creative.url || _.get(this.creative, 'file.$ngfBlobUrl')
  }

  openPreview(){
    this.updateUrlWithCreativeId();
    this.showPreviewModal(this.creativeUrl).then((modal) => modal.closed.then(() => this.removeCreativeIdFromUrl()));
  }

  getLivePreviewTemplate(){
    return this.DynamicBannerPreviewResource.one().customGET(this.creative.id)
      .then((res) => res)
      .catch(this.notify.apiError);
  }

  openLivePreview(){
    this.updateUrlWithCreativeId();
    let [width, height] = (this.creative.size || '').split('x').map(v => parseInt(v, '10'));
    let dynamicPreviewServiceUrl = this.$sce.trustAsResourceUrl("https://bidder.dsp.youappi.com/creative/preview/" + this.creative.id);
    this.showPreviewDynamic(dynamicPreviewServiceUrl, width, height).then((modal) => modal.closed.then(() => this.removeCreativeIdFromUrl()));
  }

  showPreviewModal(url){
    return this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++">
            <img ng-src="{{vm.url | adaptNonCDNHttpsUrls}}" style='margin-top: 15px;'/>
            <svg gg-icon='icon-close' style='position: absolute;' width="25" height="25"/>
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.url = url;
        this.close = close;
      }
    });
  }

  showPreviewDynamic(res, width, height){
    return this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++">
            <iframe ng-src="{{vm.res}}" style='margin-top: 75px;' frameborder='0' width="{{vm.width}}" height="{{vm.height}}"/>
            <svg gg-icon='icon-close' style='position: absolute; margin-top: 50px;' width="25" height="25"/>
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.res = res;
        this.width = width;
        this.height = height;
        this.close = close;
      }
    });
  }

  showCopyContentModal() {
    this.ModalService.showModal({
      template: copyContentModalTemplate(),
      controllerAs: 'vm',
      controller: 'CopyContentModalController',
      inputs: {
        creative: this.creative,
        variation: this.variation
      }
    });
  }

  buildDeepLink() {
    const variationId = this.variation && this.variation.id;
    const creativeId = this.creative && this.creative.id;
    if (!variationId || !creativeId) return null;
    const baseUrl = this.$window.location.href.replace(/#\d+(-\d+)?$/, '');
    return baseUrl + '#' + variationId + '-' + creativeId;
  }

  updateUrlWithCreativeId() {
    const deepLink = this.buildDeepLink();
    if (deepLink) {
      this.$window.history.replaceState(null, '', deepLink);
    }
  }

  removeCreativeIdFromUrl() {
    const cleanedUrl = this.$window.location.href.replace(/-\d+$/, '');
    this.$window.history.replaceState(null, '', cleanedUrl);
  }

  isUACampaign() {
    return this.campaign && this.campaign.type == 'Acquisition';
  }

  isEngagementCampaign() {
    return this.campaign && (this.campaign.type == 'Engagement' || this.campaign.type == 'EngagementCPC');
  }

  setLineEditing(line) {
    this.creative.definition.lines.forEach((l) => l.editing = false);
    line.editing = true;
  }

  removeLine(line) {
    let index = this.creative.definition.lines.indexOf(line);
    this.creative.definition.lines.splice(index, 1);
  }

  cloneLine(line) {
    let newLine = _.merge({},line,{editing: false});
    newLine.position.y = newLine.position.y + Math.round(newLine.font.lineHeight * 1.4 * newLine.font.size);
    this.creative.definition.lines.push(newLine);
  }
}

export function BannerCreativesFormComponent() {
  return {
    template,
    controller: BannerCreativesFormController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      campaign: '=',
      creative: '=',
      chosenCreatives: '=',
      variation: '=',
      disableField: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.campaigns.bannerCreativesForm', [
  'ngFileUpload',
  'app.services.progressBar',
  'angularModalService',
  ConfigsModule.name,
  ServicesModule.name,
  Filters.name
])
  .directive('bannerCreativesForm', BannerCreativesFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/creatives/bannerCreativesForm.js
 **/